module.exports = __webpack_public_path__ + "img/egg.a8a5d1a0.png";